import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.n4p_1.u4k($this.m4p_1.n4n());
  $this.o4p_1 = add($this.o4p_1, appended);
}
function updateConsumed($this) {
  $this.p4p_1 = add($this.p4p_1, subtract($this.o4p_1, $this.n4p_1.q2()));
  $this.o4p_1 = $this.n4p_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.m4p_1 = delegate;
        this.n4p_1 = new (Buffer())();
        this.o4p_1 = 0n;
        this.p4p_1 = 0n;
      }
      q4p() {
        updateConsumed(this);
        return this.p4p_1;
      }
      s4n() {
        return this.m4p_1.s4n();
      }
      u4n() {
        return this.n4p_1.v3z() && this.m4p_1.u4n();
      }
      n4n() {
        transferFromDelegate(this);
        return this.n4p_1;
      }
      *v4n(min, $completion) {
        if (this.n4n().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.m4p_1.v4n(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      f4o(cause) {
        this.m4p_1.f4o(cause);
        this.n4p_1.l6();
      }
    }
    protoOf($).b4o = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
